import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("ohr_token", r.data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-navy-950/80 border border-white/10 rounded-xl px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-gold-400/60 transition-colors";

  return (
    <div className="min-h-screen bg-navy-950 flex items-center justify-center px-5" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-gold-400/20 bg-navy-900/70 backdrop-blur-md p-10"
        data-testid="admin-login-form"
      >
        <img src="/assets/logo-dark-square.webp" alt="Open Horizon Records" className="w-28 h-28 object-cover rounded-full mx-auto mb-6" />
        <h1 className="font-serif text-2xl text-slate-50 text-center">Admin Console</h1>
        <p className="text-xs text-slate-500 text-center mt-2 mb-8 tracking-[0.2em] uppercase">Open Horizon Records</p>
        <div className="space-y-4">
          <input type="email" required placeholder="Email" className={inputCls} value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" autoComplete="username" />
          <input type="password" required placeholder="Password" className={inputCls} value={password}
            onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" autoComplete="current-password" />
          <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-50" data-testid="admin-login-button">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
